import cancer, * as CActions from 'ApplicationEntry/ducks/ProductsRiders/cancer';
import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import * as C from 'ApplicationEntry/models/ProductsRiders/Cancer/GroupCancer';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import States from 'ApplicationEntry/models/States';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import PackageSelect from '../PackageSelect';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import useBuildPremiumParameterAutoFill from './useBuildPremiumParameterAutoFill';
import {BillingAgent} from 'ApplicationEntry/models/BillingAgent';
import {StringUnion, NonEmptyString} from 'Core/models/EmptyString';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {getSitusStatefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';

type CancerProps = {
  caseDetails: CaseDetails;
  cancer: C.GroupCancer;
  billingAgent: BillingAgent;
};

const Cancer = (props: CancerProps) => {
  const dispatch = useDispatch();
  const {
    packageName,
    planType,
    calculatedPremium,
    cwa,
    policyNumber,
    replacement,
    section125,
    baseUnits,
    plan,
    jStamp,
    riderInformation,
    planOption,
    continuationOfCoverage,
    returnOfPremium,
    packageList,
  } = props.cancer;
  const {billingMode} = props.billingAgent;
  let {billingCode, situsState, userAuthorizedJStamp} = props.caseDetails as ValidGroupCaseDetails;
  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const [planLabel, setPlanLabel] = useState<HTMLLabelElement | null>();
  const [planBlurred, setPlanBlurred] = useState(false);
  const showPlanError = planBlurred && plan.key === 'Empty';
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;

  const handleAutoFillPremiumGrpProducts = useBuildPremiumParameterAutoFill();

  return (
    <>
      <div className="product-riders-section__policy-type" id="cancer-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanLabel} id="cancer-plan-label">
                    Plan
                  </InputLabel>
                  <Select
                    labelId="cancer-label-plan"
                    labelWidth={planLabel?.clientWidth}
                    id="cancer-plan"
                    value={plan.key === 'Empty' ? '' : plan.value}
                    onBlur={() => setPlanBlurred(true)}
                    onChange={event => {
                      dispatch(CActions.changePlan(event.target.value as string));
                      const caseNumber = matchCaseDetailsByType({
                        Group: groupApp =>
                          groupApp.caseNumber.key === 'Loaded'
                            ? groupApp.caseNumber.Data
                            : groupApp.caseNumber.key === 'UserAssignedCaseNumber'
                            ? groupApp.caseNumber.value
                            : '',
                        _: () => '',
                      })(props.caseDetails);

                      dispatch(CActions.getGroupCancerProducts(caseNumber, event.target.value as string));
                    }}
                  >
                    {C.plans.map(plan => (
                      <MenuItem value={plan} key={plan}>
                        {plan}
                      </MenuItem>
                    ))}
                  </Select>
                  {showPlanError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
              {plan.key === 'NonEmpty' ? (
                <>
                  <Grid item xs={12} md={3}>
                    <PackageSelect
                      packageName={packageName}
                      packageList={packageList}
                      changePackageAction={CActions.changePackage}
                      handlePackageItems={(packageItem: object) => {
                        if (billingMode.value !== '') {
                          handleAutoFillPremiumGrpProducts(plan, packageItem, billingMode, planType);
                        } else if (billingCode.value !== '') {
                          handleAutoFillPremiumGrpProducts(plan, packageItem, billingCode, planType);
                        }

                        dispatch(CActions.changePackageItem(packageItem));
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                      <InputLabel
                        id="cancer-units-label"
                        className={'product-riders-section__policy-type__form__row--label'}
                      >
                        Base Units
                      </InputLabel>
                      <Select
                        labelId="cancer-label-units"
                        id="cancer-base-units"
                        value={baseUnits.key === 'Empty' ? '' : parseFloat(baseUnits.value)}
                        onChange={event => dispatch(CActions.changeBaseUnits(event.target.value as string))}
                        disabled
                        displayEmpty
                      >
                        {C.baseUnits.map((baseUnit: number) => (
                          <MenuItem value={baseUnit} key={baseUnit}>
                            {baseUnit}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                      <InputLabel
                        id="cancer-plan-option-label"
                        className={'product-riders-section__policy-type__form__row--label'}
                      >
                        Plan Option
                      </InputLabel>
                      <Select
                        labelId="cancer-label-plan-option"
                        id="cancer-plan-option"
                        value={planOption.key === 'Empty' ? '' : parseFloat(planOption.value)}
                        onChange={event => dispatch(CActions.changePlanOption(event.target.value as string))}
                        disabled
                        displayEmpty
                      >
                        {C.planOptions.map((planOption: number) => (
                          <MenuItem value={planOption} key={planOption}>
                            {planOption}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="cancer-j-stamp"
                          checked={jStamp}
                          disabled={!userAuthorizedJStamp}
                          onChange={() => dispatch(CActions.changeJStamp(!jStamp))}
                        />
                      }
                      label={<Typography className="case-details-section__checkbox-label">J-Stamp</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControl
                      error={showPlanTypeError}
                      variant="outlined"
                      className="product-riders-section__policy-type__form__row--field"
                    >
                      <InputLabel
                        id="cancer-plantype-label"
                        className={'product-riders-section__policy-type__form__row--label'}
                      >
                        Plan Type
                      </InputLabel>
                      <Select
                        labelId="cancer-label-plantype"
                        id="cancer-plantype"
                        value={planType.key === 'Empty' ? '' : planType.value}
                        onBlur={() => setBlurPlanType(true)}
                        onChange={event => {
                          dispatch(CActions.changePlanType(event.target.value as string));
                          if (billingMode.value !== '') {
                            handleAutoFillPremiumGrpProducts(
                              plan,
                              null,
                              billingMode,
                              NonEmptyString.create(event.target.value as string) as StringUnion,
                              undefined,
                              undefined,
                              undefined,
                              packageList,
                              packageName
                            );
                          } else if (billingCode.value !== '') {
                            handleAutoFillPremiumGrpProducts(
                              plan,
                              null,
                              billingCode,
                              NonEmptyString.create(event.target.value as string) as StringUnion,
                              undefined,
                              undefined,
                              undefined,
                              packageList,
                              packageName
                            );
                          }
                        }}
                      >
                        <MenuItem value="IND">Individual</MenuItem>
                        <MenuItem
                          value="INDSPS"
                          disabled={
                            plan.value === 'GVCP2' ||
                            (plan.value === 'GVCP3' && props.cancer?.coverageTiers?.value === '1')
                          }
                        >
                          Individual+Spouse
                        </MenuItem>
                        <MenuItem
                          value="INDCH"
                          disabled={
                            plan.value === 'GVCP2' ||
                            (plan.value === 'GVCP3' && props.cancer?.coverageTiers?.value === '1')
                          }
                        >
                          Individual+Children
                        </MenuItem>
                        <MenuItem value="FAMILY">Family</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                      <InputLabel
                        id="cancer-situs-label"
                        className="product-riders-section__policy-type__form__row--label"
                      >
                        Situs State
                      </InputLabel>
                      <Select
                        labelId="cancer-label-situs"
                        id="cancer-situs"
                        value={situsState.value || props.cancer.situsState.value}
                        onChange={e => {
                          dispatch(CActions.changeSitusState(e.target.value as string));
                          dispatch(getSitusStatefromCaseNumber(''));
                        }}
                        displayEmpty
                      >
                        {States.map(stateCode => (
                          <MenuItem key={stateCode} value={stateCode}>
                            {stateCode}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-premium"
                      label="Premium"
                      variant="outlined"
                      placeholder="Enter Premium"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={calculatedPremium.value}
                      onChange={event => {
                        dispatch(CActions.changePremium(event.target.value as string));
                        dispatch(CActions.changeCalculatedPremium(event.target.value as string));
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-cwa"
                      label="CWA"
                      variant="outlined"
                      placeholder="Enter CWA"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={cwa.value}
                      onChange={event => dispatch(CActions.changeCWA(event.target.value as string))}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="cancer-section-125"
                          checked={section125}
                          onChange={() => dispatch(CActions.changeSection125(!section125))}
                        />
                      }
                      label={<Typography>Section 125</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="checkedB"
                          color="secondary"
                          id="cancer-replacement"
                          checked={replacement}
                          onChange={() => dispatch(CActions.changeReplacement(!replacement))}
                        />
                      }
                      label={<Typography>Replacement</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="cancer-policy-number"
                      label="Policy Number"
                      variant="outlined"
                      placeholder="Enter Policy Number"
                      margin="normal"
                      fullWidth
                      error={showPolicyNumberError}
                      helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                      className="product-riders-section__policy-type__form__row--field"
                      value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                      onBlur={() => setPolicyNumberBlurred(true)}
                      onChange={event => dispatch(CActions.changePolicyNumber(event.target.value as string))}
                      disabled={!replacement}
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  </Grid>
                </>
              ) : null}
            </Grid>
            {plan.key === 'NonEmpty' ? (
              <FixedCodeRiderInformation
                riderInformation={riderInformation}
                changeRiderInformationAction={CActions.changeRiderInformation}
                isDisabled={true}
                identifier={'group-cancer'}
              />
            ) : null}
          </div>
        </form>
      </div>
    </>
  );
};

export default Cancer;
